import React, { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { LOGO, PHONE_NUMBER, PHONE_TEL_HREF } from '../constants/site';
import { NavLink } from './nav/NavLink';
import { VeteransBadge } from './nav/VeteransBadge';
import { QuickSearchDropdown } from './nav/QuickSearchDropdown';
import { MobileMenu } from './nav/MobileMenu';
import { UserMenu } from './UserMenu';

const desktopLinkCls =
  'text-white hover:text-gold-400 transition-colors font-medium text-[13px] uppercase tracking-wide whitespace-nowrap';

const TopBanner = () => (
  <div className="fixed top-0 left-0 right-0 z-50 bg-gold-400 py-3">
    <div className="max-w-7xl mx-auto px-4 flex items-center justify-center space-x-4">
      <a href={PHONE_TEL_HREF} data-testid="top-banner-phone" className="flex items-center justify-center space-x-2 text-[#143160] font-black text-base sm:text-lg hover:scale-105 transition-transform min-h-[44px]">
        <Phone className="w-5 h-5 animate-pulse" />
        <span>CALL JESS: {PHONE_NUMBER}</span>
      </a>
      <span className="hidden sm:inline text-[#143160] font-semibold">|</span>
      <span className="hidden sm:inline text-[#143160] font-semibold">Available 7 Days a Week!</span>
    </div>
  </div>
);

const Brand = () => (
  <div className="flex items-center space-x-4">
    <img
      src={LOGO}
      alt="Jess Sells East Coast"
      className="h-14 w-auto object-contain"
      fetchPriority="high"
      decoding="async"
      style={{ filter: 'brightness(0) invert(1) sepia(1) saturate(5) hue-rotate(180deg)' }}
    />
    <div className="hidden sm:block xl:hidden w-px h-10 bg-white/30"></div>
    <div className="hidden sm:flex xl:hidden">
      <VeteransBadge />
    </div>
  </div>
);

export const Navbar = ({ navItems }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <TopBanner />
      <nav className="fixed top-10 left-0 right-0 z-50 bg-[#143160]/95 backdrop-blur-sm shadow-xl" data-testid="primary-navbar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Brand />

            <div className="hidden xl:flex items-center space-x-5">
              {navItems.map((item) => (
                <NavLink key={item.label} item={item} className={desktopLinkCls} />
              ))}
            </div>

            <div className="flex items-center space-x-3">
              <QuickSearchDropdown navItems={navItems} />
              <UserMenu />

              <a href={PHONE_TEL_HREF} className="hidden md:flex items-center space-x-2 text-white border-2 border-white/30 rounded-full px-4 py-2 hover:bg-sand-50 hover:text-[#143160] transition-all font-semibold text-sm">
                <Phone className="w-4 h-4" />
                <span className="hidden md:inline whitespace-nowrap">{PHONE_NUMBER}</span>
              </a>

              <button
                data-testid="mobile-menu-toggle"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="xl:hidden flex items-center justify-center w-11 h-11 bg-white/10 rounded-xl text-white hover:bg-white/20 transition-colors"
                aria-label="Toggle mobile menu"
              >
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>

          {isMenuOpen && <MobileMenu navItems={navItems} onClose={() => setIsMenuOpen(false)} />}
        </div>
      </nav>
    </>
  );
};
